/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class TenantStoreConstants {
}
TenantStoreConstants.GLOBAL_KEY = 'window.sirius.shared.tenantStore';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVuYW50LXN0b3JlLWNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvdGVuYW50LXN0b3JlL3RlbmFudC1zdG9yZS1jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sb0JBQW9COztBQUNOLCtCQUFVLEdBQUcsa0NBQWtDLENBQUMifQ==